/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplatePlanResponse {
    getFixupPrototypeFunction() { return TemplatePlanResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplatePlanResponse>): TemplatePlanResponse {
        let obj = Object.assign(new TemplatePlanResponse(), model);
        TemplatePlanResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplatePlanResponse>): TemplatePlanResponse {
        if (!model) return null;
        return TemplatePlanResponse.newInstance(<TemplatePlanResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplatePlanResponse) {
        if (!obj) return;

        models.TemplatePlanResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplatePlanResponse): boolean {
        Object.setPrototypeOf(obj, TemplatePlanResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Human-readable output describing what the execution would change
     */
    content: string;

    /**
     * ID of the Terraform plan this call generated. Pass it back as plan_reference_id on Execute to apply exactly this plan instead of re-planning. Terraform templates only.
     */
    plan_reference_id: string;

}
